export const MAX_INDEX_VALUE = 1000;
export const IFRAME_URL = 'http://localhost/index.php';
export const DELIVERY = 'delivery';
export const PICKUP = 'pickup';
export const DINEIN = 'dinein';
export const DINING_OPTIONS = {
  Pickup: 'Pickup',
  Delivery: 'Delivery',
  DineIn: 'Dine-In',
};
export const IN_STOCK = 'instock';
export const OUT_OF_STOCK = 'outstock';
export const OUT_OF_STOCK_ITEM_LEVEL = 'I';
export const OUT_OF_STOCK_MODIFIER_LEVEL = 'M';
export const OUT_OF_STOCK_LEVELS = [
  OUT_OF_STOCK_ITEM_LEVEL,
  OUT_OF_STOCK_MODIFIER_LEVEL,
];
export const BUFFER_TIME = 0;
export const SOMETHING_WENT_WRONG = 'Something went wrong please try again';
export const GA_TRACKING_PREFIX = 'ua';
export const GA_GTM_PREFIX = 'gtm';
export const TYPE_DELIVERY = 2;
export const TYPE_PICKUP = 1;
export const TYPE_DINE_IN = 3;

// No restaurant opening later in the same day
export const TEXT_OPENING_SHORTLY = 'opening-shortly';

export const TIME_OUT_MINUTES = 30;

export const TIMEFORMAT = 'hh:mm:a';

// Modifier Types
export const MODIFIER_FORCED = 'forced';
export const MODIFIER_DETOR = 'detor';
export const MODIFIER_OPTIONAL = 'optional';



// WEBPACK FOOTER //
// ./src/util/Constants.js